/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    pre: "pre",
    code: "code",
    h2: "h2"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h1, {
    id: "iconbutton"
  }, "IconButton"), "\n", React.createElement(_components.p, null, "Transparent button for SVG icons"), "\n", React.createElement(_components.pre, null, React.createElement(_components.code, {
    className: "language-js"
  }, "import { IconButton } from 'theme-ui'\n")), "\n", React.createElement(_components.pre, null, React.createElement(_components.code, {
    className: "language-jsx",
    live: "true"
  }, "<IconButton aria-label=\"Toggle dark mode\">\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    viewBox=\"0 0 24 24\"\n    width=\"24\"\n    height=\"24\"\n    fill=\"currentcolor\">\n    <circle\n      r={11}\n      cx={12}\n      cy={12}\n      fill=\"none\"\n      stroke=\"currentcolor\"\n      strokeWidth={2}\n    />\n  </svg>\n</IconButton>\n")), "\n", React.createElement(_components.h2, {
    id: "variants"
  }, "Variants"), "\n", React.createElement(_components.p, null, "IconButton variants can be defined in the ", React.createElement(_components.code, null, "theme.buttons"), " object.\nBy default the IconButton component will use styles defined in ", React.createElement(_components.code, null, "theme.buttons.icon"), "."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
